// removed by extract-text-webpack-plugin
module.exports = {"VehicleBatchEdit":"VehicleBatchEdit--3be4M","List":"List--2NmpS","Item":"Item--1whHV","EmptyLabel":"EmptyLabel--1hzmK","EditTags":"EditTags--3B3iV"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Pages/Vehicle/BatchEdit/BatchEdit.local.css
// module id = 965
// module chunks = 1